import React, { createContext, useContext, useState } from "react";
import { toast } from 'react-toastify';
import { fetchConversationTemplateTableAndFilterSchema } from "model/ConversationTemplateModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const ConversationTemplateContext = createContext();

export const ConversationTemplateProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [conversationTemplateContextData, setConversationTemplateContextData] = useState();

    const fetchConversationTemplateContextData = async () => {
        setLoading(true);
        try {
            const response = await fetchMetadataSchema("metadata:conversationTemplate", () =>
                fetchConversationTemplateTableAndFilterSchema([])
            );
            if (response?.success) {
                setConversationTemplateContextData(response?.data);
            }
        } catch (err) {
            toast.error(err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConversationTemplateContext.Provider
            value={{
                fetchConversationTemplateContextData,
                conversationTemplateContextData,
                loading,
                error,
            }}
        >
            {children}
        </ConversationTemplateContext.Provider>
    );
};

export const useConversationTemplateContext = () => useContext(ConversationTemplateContext);
